import { PostsState } from "@/store/types/posts.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { mutations } from "./mutations";

export const state: PostsState = {
    entries: [],
    loading: false,
};

const namespaced = true;

export const PostsModule: Module<PostsState, RootState> = {
    namespaced,
    actions,
    mutations,
    state,
}